import { ContainerV1IsEmptyFn } from "@adobe/aem-core-components-react-spa";

export default {
  title: "Container",
  type: "rh/components/content/container", // Unique type for the new container
  isContainer: true,
  config: {
    emptyLabel: "Container",
    isEmpty: ContainerV1IsEmptyFn
  }
};
